export const styles = {
	priorityList: {
		border: '1px solid #ccc',
		borderRadius: '5px',
		padding: '10px',
		width: '100p%',
		marginBottom: '20px',
		marginLeft: '100px',
		marginRight: '100px'
	},
	tag: {
		display: 'inline-block',
		backgroundColor: '#007bff',
		color: '#fff',
		padding: '5px 10px',
		borderRadius: '10px',
		marginRight: '5px',
		marginBottom: '5px',
		marginTop: '15px'
	},
	updateSection: {
		marginTop: '20px'
	},
	textarea: {
		width: '100%',
		marginBottom: '10px'
	},
	button: {
		padding: '10px 20px',
		backgroundColor: 'black',
		color: '#fff',
		border: 'none',
		borderRadius: '5px',
		cursor: 'pointer'
	},
	mainContainer: {
		height: '100%',
		overflow: 'auto'
	},
	mainHeading: {
		padding: '10px',
		margin: '0 100px'
	}
};
